import { useRef, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { ChatPanel } from "./ChatPanel";

export function ChatWindow({ title, channel, testid, onClose, initialText = "" }) {
  const winRef = useRef(null);
  const drag = useRef(null);
  const [pos, setPos] = useState(null);

  const startDrag = (e) => {
    if (e.button !== undefined && e.button !== 0) return;
    if (e.target.closest("button")) return;
    if (window.innerWidth < 640) return;
    const rect = winRef.current.getBoundingClientRect();
    drag.current = { dx: e.clientX - rect.left, dy: e.clientY - rect.top };
    const move = (ev) => {
      const x = Math.min(Math.max(0, ev.clientX - drag.current.dx), window.innerWidth - 120);
      const y = Math.min(Math.max(0, ev.clientY - drag.current.dy), window.innerHeight - 80);
      setPos({ x, y });
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  return (
    <div
      ref={winRef}
      className={`fixed z-50 flex flex-col rounded-2xl border border-border bg-card shadow-2xl ${pos ? "" : "left-3 right-3 top-24 bottom-3 sm:left-auto sm:right-6 sm:top-20 sm:bottom-6 sm:w-[560px] lg:w-[640px]"}`}
      style={pos ? { left: pos.x, top: pos.y, width: "min(640px, calc(100vw - 24px))", height: "min(80vh, calc(100vh - 24px))" } : undefined}
      data-testid={testid}
    >
      <div className="flex items-center gap-2 px-4 py-3 border-b border-border sm:cursor-move select-none sm:touch-none shrink-0" onPointerDown={startDrag} data-testid={`${testid}-dragbar`}>
        <MessageCircle className="w-5 h-5 text-sky-400 shrink-0" />
        <div className="font-heading font-semibold text-sm truncate flex-1">{title}</div>
        <button type="button" onPointerDown={(e) => e.stopPropagation()} onPointerUp={(e) => e.stopPropagation()} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClose(); }}
          className="-mr-2 p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted active:bg-muted transition-colors shrink-0 touch-manipulation" title="Tutup" aria-label="Tutup chat" data-testid={`${testid}-close`}>
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <ChatPanel channel={channel} testid={`${testid}-panel`} initialText={initialText} />
      </div>
    </div>
  );
}
